import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';

import { AddBrokerComponent } from '@shared/modules/add-broker/add-broker.component';
import { BrokerService } from '@app/_shared/modules/add-broker/provider/broker.service';
import { BrokerLoginEventI, BrokerSessionStatusFirstFetch, SavedBrokerSettings } from '@app/_shared/modules/add-broker/provider/broker.interface';
import { BrokerLogo } from '@app/_shared/modules/add-broker/provider/broker.enums';
import { DATE_TIME_FORMAT } from '@app/_helpers';
import { DELETE_BROKER_WARNING, BROKER_LOGOUT_WARNING, ConfirmationDialogService, NgxToastrService, StrategiesService, SubjectType, BROKER_LOGIN_SUCCESSFUL } from '@app/_shared';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-brokers',
  templateUrl: './brokers.component.html',
  styleUrls: ['./brokers.component.scss']
})
export class BrokersComponent implements OnInit {
  connectionStatus: BrokerSessionStatusFirstFetch;
  savedBrokers: SavedBrokerSettings;
  BrokerLogo = BrokerLogo;
  DATE_TIME_FORMAT = DATE_TIME_FORMAT;

  currentBroker: string;
  loginRequest: boolean = false;
  constructor(
    private matDialog: MatDialog,
    private brokerService: BrokerService,
    private toastService: NgxToastrService,
    private booksSocketService: BooksSocketService,
    private strategiesService: StrategiesService,
    private confirmationService: ConfirmationDialogService,
    @Optional() @Inject(MAT_DIALOG_DATA) public isDialog: string,
  ) { }

  ngOnInit(): void {
    this.getSavedBrokers();

    this.brokerService.getBrokerSession().subscribe((res) => {
      this.connectionStatus = res;
    })

    this.booksSocketService.getSubject(SubjectType.BROKER).subscribe((res: BrokerLoginEventI) => {
      this.brokerService.brokerSessionStatus = {
        is_connected: res.isSuccess,
        reason: res.text
      };
      this.connectionStatus = this.brokerService.brokerSessionStatus;
      if (this.loginRequest && this.connectionStatus.is_connected) {
        this.toastService.simpleCustomToaster(BROKER_LOGIN_SUCCESSFUL);
      }
    })

  }

  getSavedBrokers() {
    this.brokerService.getBrokerSettings().subscribe((res) => {
      this.savedBrokers = res;

      // TODO: REQUIRED:
      // get selected broker (for now we are selecting first broker)
      // require some function to get this from backend

      if (this.savedBrokers && Object.keys(this.savedBrokers).length) {
        this.currentBroker = Object.keys(this.savedBrokers)[0];
      }
      else {
        this.currentBroker = '';
      }

    });
  }

  onBrokerChange(event: MatSelectChange) {
    this.currentBroker = event.source.value;

    // TODO: implementation pending
  }

  logoutFromBroker() {
    this.confirmationService.alert({
      message: BROKER_LOGOUT_WARNING,
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.strategiesService.terminateAllStrategies();
            this.brokerService.logoutBroker(this.currentBroker).subscribe((m) => {
              this.toastService.simpleCustomToaster(m.message);
            })
          },
          accent: true
        }
      ]
    })
  }

  openAddBrokerDialog(editBroker?: string) {
    const dialog = this.matDialog.open(AddBrokerComponent, {
      data: editBroker,
    });

    dialog.afterClosed().subscribe(() => {
      this.getSavedBrokers();
    })
  }

  deleteDetails(brokerName: string) {
    this.confirmationService.alert({
      message: DELETE_BROKER_WARNING,
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.brokerService.deleteBrokerFormSettings(brokerName).subscribe(() => {
              this.toastService.simpleCustomToaster('Broker deleted successfully');
              delete this.savedBrokers[brokerName];

              this.getSavedBrokers();
            });
          },
          accent: true
        }
      ]
    })
  }
  loginFromBroker() {
    const savedSettings = cloneDeep(this.brokerService.savedSettingCached[this.currentBroker]);
    const data = {
      clientID: savedSettings.clientID,
      clientPassword: savedSettings.clientPassword,
      clientPin: savedSettings.clientPin
    };

    this.brokerService.saveBrokerFormSettings(this.currentBroker, data).subscribe(() => { })
    this.toastService.simpleCustomToaster('Login Request Sent!');
    this.loginRequest = true;
  }
}
